module.exports = __webpack_public_path__ + "img/up-banner.f0a5d6d3.png";